<template>
  <v-container fluid grid-list-md fill-height >
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
            <v-toolbar-title class="text-xs-center">
              Manage Estimate
            </v-toolbar-title>
            <v-spacer />
              <v-select
                solo
                clearable 
                v-model="statusFilter" 
                :items="['IN PROGRESS','CANCELLED','BILLED','ALL']" 
                label="Filter">
              </v-select>
            <v-spacer></v-spacer>   
            <v-btn outlined @click="estimateDialog = true">
              <v-icon left color="teal">add</v-icon>
              New Estimate
            </v-btn>
            <!-- <router-link to="/Dashboard">
            <v-btn icon>
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </router-link> -->
        </v-toolbar>


        <v-data-table
          :headers="estimateHeader"
          :items="estimatesByBrand"      
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
             <td>
                <!-- <v-icon :disabled="props.item['status']=='CANCELLED' || props.item['status']=='BILLED'" @click="openProd(props.item)" color="primary">remove_red_eye</v-icon> -->
                <v-icon :disabled="props.item['status']=='CANCELLED' || props.item['status']=='BILLED' || getCustomerName(props.item.buyerId) == 'DELETED CUSTOMER'" @click="openProd(props.item)" color="primary">remove_red_eye</v-icon>
              </td>
            <td>
              <b>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</b>
            </td>
            <td>
              <b>{{props.item['invoiceDate'] ? new Date(props.item.invoiceDate).toLocaleDateString('en-GB'): ''}}</b>
            </td>
            <!-- <td>
              <b>{{props.item['estimateNumber']}}</b>
            </td> -->
            <td>
              <b>{{getCustomerName(props.item.buyerId)}}</b>
            </td>
            <td>
              <b class="font-weight-bold red--text">{{getTotal(props.item) || 0 | amount }}</b>
            </td>
            <td>
              <b>{{props.item['remark']}}</b>
            </td>
            <!-- <td>
              <b>{{props.item['remainingAmountEstimate']}}</b>
            </td> -->
            <!-- <td>
              <b>{{props.item['.key']}}</b>
            </td> -->
            <!-- <td>
              <b>{{getFirmName(props.item.firm)}}</b>
            </td> -->
            <td>
              <b>{{props.item['status']}}</b>
            </td>
            <td v-if="props.item['status']!='CANCELLED'">
              <v-btn v-if="props.item['status'] == 'IN PROGRESS'" icon class="mx-0" @click="cancelEstimate(props.item)">
                <v-icon color="pink">cancel</v-icon>
              </v-btn>
              <v-btn v-else icon class="mx-0" @click="dispatchEstimate(props.item)">
                <v-icon color="pink">commute</v-icon>
              </v-btn>
            </td>
            <td v-else></td>
            <td>
              <!-- <v-btn icon class="mx-0" @click="editEstimate(props.item)"> -->
              <v-btn icon class="mx-0" v-if="props.item['status'] == 'IN PROGRESS'" @click="editEstimate(props.item)">
                <v-icon color="green">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteEstimate(props.item)">
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </td>
            <td>
                 <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        icon class="mx-0"
                      >
                        <v-icon color="blue">print</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        @click="printEstimate(props.item,true)">
                        <v-list-tile-title>
                          Taxable Print
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        @click="printEstimate(props.item,false)">
                        <v-list-tile-title>
                          Simple Print
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    
    <!-- Start Product Transfer Dialog -->
    <v-dialog v-model="estimateDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <!-- <span class="headline">Create Estimate</span> -->
          <span class="headline" v-if="isEdit">Edit Estimate</span>
          <span class="headline" v-else>Create Estimate</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
            <v-flex xs12 sm12 md12>
           <v-switch
              :disabled="isEdit"
              v-model="isBuyer"
              :label="`${isBuyer ? 'Sale Estimate' : 'Purchase Estimate'}`"
            ></v-switch>
        </v-flex>

        <v-flex xs12 sm4 md4>
           <v-select 
                v-bind:items="isBuyer ? buyersByBrand : sellersByBrand"
                v-model="selectedBuyer" 
                :label="isBuyer ? 'Select or add Buyer' : 'Select or add Seller'"
                autocomplete
                :disabled="isEdit"
                item-text="name"
                return-object
                @keyup.native.enter="addCustomer"
            >   
           </v-select>
        </v-flex>
         <v-flex xs4>
            <v-select
              dense
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
            ></v-select>
          </v-flex>
            
            <v-flex xs12 sm4 md4>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerEstimate"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="date"
                    label="Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="date" @input="datepickerEstimate = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  v-model="remark"
                  prefix="#"
                  label="Remark"
                  placeholder="Enter Remark"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-combobox
                  v-model="productsToEstimate"
                  :items="productListByBrand"
                  :return-object="true"
                  item-text="name"
                  @change="addToBucket()"
                  label="Product"
                  multiple
                ></v-combobox>
              </v-flex>
               <v-flex xs12 sm12 md12>
                  <v-layout wrap>
                    <template v-for="item in items">
                    <v-flex :key="item.productId" xs3 sm3 md3>
                      {{item.productName}}
                    </v-flex>
                    <v-flex :key="item.productName" xs3 sm3 md3>
                      <v-text-field type="text" v-model="item.subDescription" label="Sub Description">
                      </v-text-field>
                    </v-flex>
                    <v-flex :key="item.productName" xs3 sm1 md1>
                      <v-text-field type="number" v-model.number="item.quantity" label="Quantity">
                      </v-text-field>
                    </v-flex>
                    <v-flex xs1 sm1 md1 :key="item.unit" >
                      <v-select
                        dense
                        item-text="text"
                        item-value="value"
                        :items="units"
                        label="Select unit"
                        v-model="item.unit"
                      ></v-select>
                    </v-flex>
                    <v-flex :key="item.productName+'RATE'" xs2 sm2 md2>
                      <v-text-field type="number" v-model.number="item.rate" label="Rate">
                      </v-text-field>
                    </v-flex>
                    <v-flex :key="item.productName+'total'" xs2 sm2 md2>
                      <v-text-field type="number" :value="(item.rate ? Number.parseFloat(item.rate) : 0 ) * (item.rate ? Number.parseFloat(item.quantity) : 0 )" :disabled="true" label="Total">
                      </v-text-field>
                    </v-flex>
                    </template>
                  </v-layout>
               </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                @click="estimateDialog = false"
                flat
              >Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                :disabled="!items.length || !selectedBuyer || !selectedFirm"
                @click="addEstimate()"
                flat
              >{{isEdit ? 'Save' : 'Create' }}</v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>

       <v-dialog v-model="invoiceEstimate" width="800" v-if="selectedEstimate && selectedEstimate['.key']">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>Estimate details:- 
            <!-- {{selectedEstimate['.key']}} -->
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="productInvoiceHeader"
              :items="selectedEstimate.items"
              class="elevation-1 dashboardHead"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <b>{{ props.item['productName']}} - {{ props.item['subDescription']}}</b>
                </td>
                <td>
                  <b>{{ props.item['quantity']}}</b>
                </td>
                <td>
                  <b>{{ props.item.unit}}</b>
                </td>
                <td>
                  <b><v-text-field  type="number" v-model.number="props.item.rate" label="Product Rate"></v-text-field></b>
                </td>
                <td>
                  <v-text-field type="number" :value="(props.item.rate ? Number.parseFloat(props.item.rate) : 0 ) * (props.item.rate ? Number.parseFloat(props.item.quantity) : 0 )" :disabled="true" label="Total">
                  </v-text-field>
                </td>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="primary" text @click="invoiceEstimate = false">Back</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="createInvoice()">Create Invoice </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      

  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
import { convertToEstimate,convertToEstimateWithoutGST} from "../../utils/estimatePdf";
export default {
  data() {
    return {
      productsToEstimate : [],
      items:[],
      isEdit:false,
      estimateDialog: false,
      isBuyer : true,
      invoiceEstimate : false,
      selectedEstimate : null,
      selectedBuyer : null,
      selectedFirm : null,
      date:  new Date().toISOString().substr(0, 10),
      datepickerEstimate: false,
      statusFilter : 'ALL',
      remark: null,
      estimateHeader: [
        { text: "View", value: "quantity" },
        { text: "Estimate Date", value: "quantity" },
        { text: "Invoice Date", value: "quantity" },
        // { text: "Estimate Number", value: "deposit - ID" },
        { text: "Customer Name", value: "name" }, 
        { text: "Total Amount", value: "name" }, 
        // { text: "Remaining Estimate", value: "name" }, 
        // { text: "Estimate - ID", value: "deposit - ID" },
        { text: "Remark", value: "remark" },
        { text: "Status", value: "edit" },
        { text: "Cancel", value: "edit" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "edit" },
        { text: "Print", value: "edit" },
      ],
      productInvoiceHeader: [
        { text: "Name", value: "Name" },
        { text: "Description", value: "Taxable" },
        { text: "Quantity", value: "Taxable" },
        { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" },
        { text: "Total", value: "total" },
      ]
    };
  },
  created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("estimates", this.$root.$firebaseRefs.estimates.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject('sellerById', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsObject('productById', this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand",'finYear']),
    ...mapGlobalGetters({ units: "productUnit" }),
    productListByBrand() {
      let prod = this.products.filter(
        item => {
          return (item["brand"] === this.selectedBrand &&
          (this.selectedFirm ? item["firm"] === this.selectedFirm  : false))
          // && (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true))
        }
      );
      return prod;
    },
    estimatesByBrand(){
      return this.estimates.filter(
        item => {
          return ((item["brand"] === this.selectedBrand && 
          (item.date ? (item.date >= this.finYear.start) && (item.date <= this.finYear.end) : true)) &&
          (this.statusFilter != 'ALL' ? item.status == this.statusFilter : true))
        }
      );
    },
    buyersByBrand(){
      return this.buyers
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand
          );
        })
    },
    sellersByBrand(){
      return this.sellers
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand
          );
        })
    },
    firmsByBrand() {
      return this.firms
        .filter(item => item["brand"] === this.selectedBrand)
        .map(item => {
          if (item.defaultFirm) {
            this.selectedFirm = item[".key"];
          }
          return {
            text: item["name"],
            value: item[".key"]
          };
        });
    },
    
  },
  methods: {
    openProd(item){
      this.selectedEstimate =item; 
      this.invoiceEstimate = true;
    },
    getTotal(item){
      let total = 0;
      item.items.map((i)=>{
        total += Number.parseFloat((Number.parseFloat(i.rate)) * (Number.parseFloat(i.quantity)))
      })
      return total;
    },
    getFirmName(e){
      let firm;
        if (this.firms && this.selectedBrand) {
          firm =this.firms.filter(item => item['.key'] === e)[0]
        }
      if(firm)
        return firm.name
    },
    async printEstimate(invoiceData,isGST) {
      let firm  =this.firms.filter(item => item['.key'] === invoiceData['firm'])[0];
      let customer = invoiceData.isBuyer ? this.buyerById[invoiceData.buyerId] : this.sellerById[invoiceData.buyerId];
      firm.address = this.getAddress(firm);
      customer.address = this.getAddress(customer);
      let termsAndConditions = this.getTermsAndConditions(invoiceData);
      let gstTotal = this.calculateGSTInvoice(customer,invoiceData,firm);
      if(isGST) {
        await convertToEstimate({
          invoiceData : invoiceData,
          firm : firm,
          customer : customer,
          terms : termsAndConditions[0],
          gstTotal : gstTotal
        }).then((doc) => {
          pdfMake.createPdf(doc).download();
        });
      } else {
        await convertToEstimateWithoutGST({
          invoiceData : invoiceData,
          firm : firm,
          customer : customer,
          terms : termsAndConditions[0],
          gstTotal : gstTotal
        }).then((doc) => {
          pdfMake.createPdf(doc).download();
        });
      }
     
    },
    getTermsAndConditions(invoiceData) {
      let termsAndConditions = this.termsAndConditions.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["firm"] === invoiceData.firm
      );
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.bankById[bankId];
            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      return termsAndConditions;
    },
    getAddress(item) {
      if (!item) {
        return "";
      }
      let address =
        (item.village ? item.village + " - " : "") +
        (item.block ? item.block + " - " : "") +
        (item.tehsil ? item.tehsil + " - " : "") +
        (item.district ? item.district + " - " : "") +
        (item.state ? item.state + " - " : "") +
        (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    calculateGSTInvoice(currentUser, invoice,firm) {
      let SGST_val = 0;
      let CGST_val = 0;
      let IGST_val = 0;
      invoice.items && invoice.items.map((item, index) => {
        let prod = this.products.filter(p => p['.key'] === item['productId'])[0];
        item["taxableGST_rate"] = prod['taxableGST_rate'];
        item.HSN_code = prod["HSN_code"];
        item.basicPrice = (Number.parseFloat(item.rate * item.quantity)).toFixed(2);
        item.GSTValue = Number.parseFloat(item.basicPrice * (parseFloat(item.taxableGST_rate)/100)).toFixed(2);
        item.totlePrice = Number.parseFloat((Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue))).toFixed(2);
        let GST = item["taxableGST_rate"];
         if (
            !currentUser.state ||
            (firm &&
              currentUser.state &&
              Number.parseFloat(GST) &&
              firm.state === currentUser.state)) {
            item["CGST_val"] = item["GSTValue"] / 2;
            item["CGST"] = GST / 2;
            item["SGST_val"] = item["GSTValue"] / 2;
            item["SGST"] = GST / 2;
            item["IGST"] = 0;
            item["IGST_val"] = 0;
          } else {
            item["IGST"] = GST;
            item["CGST"] = 0;
            item["SGST"] = 0;
            item["IGST_val"] = item["GSTValue"];
            item["CGST_val"] = 0;
            item["SGST_val"] = 0;
          }
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val, CGST_val, IGST_val };
    },
    getCustomerName(id) {
      let buyer = this.buyerById[id];
      let seller = this.sellerById[id];
      if(!buyer && !seller) {
        return 'DELETED CUSTOMER'
      }
      return buyer ? buyer.name : seller.name;
    },
    addToBucket(){
      let tempIts = this.items;
      this.items = [];
      let buyer = this.isBuyer ? this.buyers.find(i => i['.key'] == this.selectedBuyer) : null;
         
      this.productsToEstimate.map((prod)=>{
        let selectedProd = tempIts.filter(item => item['productId'] == prod['.key'])[0]
        let temp = {
          productName:prod.name,
          subDescription:prod.subDescription,
          productId:prod['.key'],
          quantity:selectedProd && selectedProd.quantity ?  selectedProd.quantity : 1,
          unit: selectedProd && selectedProd.unit ?  selectedProd.unit : prod.unit,
          rate : selectedProd && selectedProd.rate ?  selectedProd.rate : (this.isBuyer ? prod["sellingPrice"] || 0 : prod["purchasingPrice"] || 0)
        }
        if(buyer && buyer.category && prod.sellingPriceByCategories && prod.sellingPriceByCategories[buyer.category]) {
          temp['rate'] = prod.sellingPriceByCategories[buyer.category]
        }
        this.items.push(temp);
      })
    },
    addCustomer:function(e){
      let obj = {
        name :  e.target.value,
        brand : this.selectedBrand
      }
      if(this.selectedFirm) {
        obj['state'] = this.selectedFirm
      }

      if(this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    createInvoice(){
      let key = this.selectedEstimate['.key'];
      delete this.selectedEstimate['.key'];
      this.$root.$firebaseRefs.estimates.child(key).set(this.selectedEstimate).then((snap)=>{
        this.selectedEstimate = null;
        this.$router.push({path: `/estimate-to-invoice/${key}` })
        this.invoiceEstimate = false;
      });
    },
    cancelEstimate(estimate){
        let key = estimate['.key'];
        delete estimate['.key'];
        estimate['status'] = 'CANCELLED'
        this.$root.$firebaseRefs.estimates.child(key).set(estimate).then((snap)=>{
        });
    },
    editEstimate(estimate){
      this.productsToEstimate = [];
      this.estimateDialog = true;
      this.isEdit = true;
      this.items = estimate.items;
      this.firm = estimate.firm;
      this.date = new Date(estimate.date).toISOString().substr(0, 10),
      this.selectedEstimate = estimate;
      this.isBuyer = estimate.isBuyer;
      this.remark = portfolio.remark;
      if(estimate.isBuyer) {
        this.selectedBuyer = this.buyerById[estimate.buyerId]
      } else {
        this.selectedBuyer = this.sellerById[estimate.buyerId]
      }
      this.items.map((item)=>{
        this.productsToEstimate.push(this.productById[item.productId])
        // this.productsToEstimate.push(obj)   
      })
    },
    addEstimate(){
      let estimateObj = {
        buyerId : this.selectedBuyer['.key'],
        isBuyer: this.isBuyer,
        remark: this.remark,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        items: this.items,
      }
      //   status: 'IN PROGRESS'
      // }
      // this.$root.$firebaseRefs.estimates.push(estimateObj);
      if(this.isEdit ) {
        estimateObj['status'] = this.selectedEstimate['status']; 
        estimateObj['buyerId'] = this.selectedEstimate['buyerId']; 
        this.$root.$firebaseRefs.estimates.child(this.selectedEstimate['.key']).set(estimateObj).then((snap)=>{
            this.isEdit = false;
        });
      } else {
        estimateObj['status'] = 'IN PROGRESS';
        this.$root.$firebaseRefs.estimates.push(estimateObj);
      }
      this.estimateDialog = false;
      this.selectedBuyer = null;
      this.remark = null;
      this.isBuyer = true;
      this.items = [];
      this.productsToEstimate = [];
    },
    deleteEstimate(estimate) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.estimates.child(estimate[".key"]).remove();
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/RecordEstimate/recordEstimate.vue